import React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { connect } from 'dva';
import { Link } from 'dva/router';
import { Table, Icon, Row, Button, Modal, Spin, Col, Tooltip } from 'antd';
import Sticky from 'react-sticky-el';
import { AjaxTable, SearchComponent, ImportFile } from '../../../../components';
import MultiplyItemsColumnRender from '../../../common/Table/MultiplyItemsColumnRender';

import styles from '../../styles.less';
import { PencilIcon, TrashIcon } from '../../../Icons';

class CompaniesList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      removedId: 0,
      filter: {},
    };
  }

  componentDidMount() {
    this.props.dispatch({
      type: 'header/update',
      payload: {
        title: 'Component.Company.List.Title',
      },
    });
    this.showNotifications();
  }

  getData = (psf) => {
    const projectId = this.props.app.currentProjectId || this.props.match.params.projectId;

    return this.props.dispatch({
      type: 'companies/loadAttributes',
      payload: Object.assign({}, psf, { projectId, filter: { name: this.state.filter.search } }),
    });
  }

  showNotifications() {
    this.props.dispatch({ type: 'app/showNotifications' });
  }

  remove(id) {
    const projectId = this.props.app.currentProjectId;

    this.props.dispatch({
      type: 'companies/remove',
      payload: {
        projectId,
        companyId: id,
      },
    }).then(() => {
      this.showNotifications();
      this.setState({ removedId: id });
    });
  }

  showDeleteConfirm(record) {
    const that = this;

    Modal.confirm({
      title: this.props.intl.formatMessage({ id: 'Common.Attention' }),
      content: this.props.intl.formatMessage({ id: 'Component.Company.Modal.Delete.Description' }),
      okText: this.props.intl.formatMessage({ id: 'Common.Remove' }),
      cancelText: this.props.intl.formatMessage({ id: 'Common.Cancel' }),
      okType: 'danger',
      onOk() {
        that.remove(record.id);
      },
    });
  }

  checkColumnData(arr, renderHTML) {
    return arr.length ? renderHTML : <FormattedMessage id="Common.NoData" />;
  }

  render() {
    const { Column } = Table;
    const projectId = this.props.app.currentProjectId;

    return (
      <div className={styles.containerLarge}>
        <Sticky
          className="sticky-bar"
          scrollElement=".ant-layout"
          stickyClassName="_sticky"
        >
          <div className="sticky-wrapper">
            <Row>
              <SearchComponent self={this} fieldPlaceholder={this.props.intl.formatMessage({ id: 'Component.Company.List.SearchByName' })} />
              <Col lg={{ span: 8 }} xl={{ span: 9 }} xxl={{ span: 11 }} className={styles.importBtnWrap}>
                <ImportFile />
              </Col>
              <Col lg={{ span: 6 }} xl={{ span: 5 }} xxl={{ span: 3 }} className="text-right">
                <Button
                  size="large"
                  type="primary"
                  onClick={() => {
                    this.props.dispatch({
                      type: 'app/goToRoute',
                      payload: { routeName: 'COMPANY_NEW', projectId },
                    });
                  }}
                >
                  <Icon type="plus" />
                  <FormattedMessage id="Component.Company.CreateButton" />
                </Button>
              </Col>
            </Row>
          </div>
        </Sticky>
        <Spin spinning={!!this.props.loading.models.companies}>
          <AjaxTable
            rowKey="id"
            scroll={{ x: 1500 }}
            updateKey={JSON.stringify([this.state.filter, this.state.removedId])}
            getData={this.getData}
          >
            <Column
              title={this.props.intl.formatMessage({ id: 'Grid.Column.Name' })}
              dataIndex="name"
              key="name"
              className={styles.tableColumnWrap}
              render={data => <div>{data}</div>}
            />

            <Column
              title={this.props.intl.formatMessage({ id: 'Grid.Column.LeadLabel' })}
              dataIndex="lead_marks"
              key="lead_marks"
              className={styles.tableColumnWrap}
              render={(leadMarks) => {
                return <MultiplyItemsColumnRender alignment="start" itemList={leadMarks.map(item => item.name)} />;
              }}
            />

            <Column
              title={this.props.intl.formatMessage({ id: 'Grid.Column.CustomerNumber' })}
              dataIndex="customer_number"
              key="customer_number"
              className={styles.tableColumnWrap}
              render={data => <div>{data}</div>}
            />
            <Column
              title={this.props.intl.formatMessage({
                id: 'Grid.Column.Actions',
              })}
              key="actions"
              className="text-center"
              width={150}
              fixed="right"
              render={item => (
                <div className="actions" data-label={item.id}>
                  <Tooltip
                    className="hint action-wrap"
                    placement="top"
                    title={this.props.intl.formatMessage({
                      id: 'Grid.Column.Edit',
                    })}
                  >
                    <Link to={`/${projectId}/company/${item.id}/edit/`}>
                      <PencilIcon />
                    </Link>
                  </Tooltip>
                  <Tooltip
                    className="hint action-wrap"
                    placement="top"
                    title={this.props.intl.formatMessage({
                      id: 'Grid.Column.Delete',
                    })}
                  >
                    <button onClick={() => this.showDeleteConfirm(item)}>
                      <TrashIcon />
                    </button>
                  </Tooltip>
                </div>
              )}
            />
          </AjaxTable>
        </Spin>
      </div>
    );
  }
}

export default connect(({ companies, app, loading }) => ({
  companies,
  app,
  loading,
}))(injectIntl(CompaniesList));



// WEBPACK FOOTER //
// ./src/components/Companies/CompaniesOverview/CompaniesList/CompaniesList.js